export class Queue<T> {
  private items: T[] = []

  constructor(items: T[] = []) {
    this.items = items
  }

  enqueue(item: T): void {
    this.items.push(item)
  }

  dequeue(): T | undefined {
    return this.items.shift() // Removes the first element
  }

  front(): T | undefined {
    return this.items[0] // Returns the first element
  }

  isEmpty(): boolean {
    return this.items.length === 0
  }

  size(): number {
    return this.items.length
  }

  clear(): void {
    this.items = []
  }

  show(): T[] {
    return [...this.items]
  }
}
